<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M17.25,24.011c-3.722,0-6.75-3.028-6.75-6.75s3.028-6.75,6.75-6.75S24,13.539,24,17.261S20.972,24.011,17.25,24.011z
		 M17.25,12.011c-2.895,0-5.25,2.355-5.25,5.25s2.355,5.25,5.25,5.25s5.25-2.355,5.25-5.25S20.145,12.011,17.25,12.011z"/>
	<path d="M17.25,18.011c-0.414,0-0.75-0.336-0.75-0.75v-2.652c0-0.414,0.336-0.75,0.75-0.75S18,14.195,18,14.609v1.902h1.902
		c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75H17.25z"/>
	<path d="M5.25,11.261c-0.414,0-0.75-0.336-0.75-0.75s0.336-0.75,0.75-0.75h5.25c0.414,0,0.75,0.336,0.75,0.75
		s-0.336,0.75-0.75,0.75H5.25z"/>
	<path d="M5.25,15.011c-0.414,0-0.75-0.336-0.75-0.75s0.336-0.75,0.75-0.75h3c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75
		H5.25z"/>
	<path d="M5.25,18.761c-0.414,0-0.75-0.336-0.75-0.75s0.336-0.75,0.75-0.75h3c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75
		H5.25z"/>
	<path d="M2.25,24.011c-1.241,0-2.25-1.009-2.25-2.25V6.011c0-1.241,1.009-2.25,2.25-2.25h3.063c0.362-2.129,2.248-3.75,4.437-3.75
		c2.19,0,4.076,1.621,4.437,3.75h3.063c1.241,0,2.25,1.009,2.25,2.25v2.25c0,0.414-0.336,0.75-0.75,0.75S18,8.675,18,8.261v-2.25
		c0-0.414-0.336-0.75-0.75-0.75H13.5c-0.414,0-0.75-0.336-0.75-0.75c0-1.654-1.346-3-3-3s-3,1.346-3,3c0,0.414-0.336,0.75-0.75,0.75
		H2.25c-0.414,0-0.75,0.336-0.75,0.75v15.75c0,0.414,0.336,0.75,0.75,0.75h7.5c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75
		H2.25z"/>
	<circle cx="9.75" cy="4.136" r="1.125"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'task-list-clock',
    },
    name: {
      type: String,
      required: false,
      default: 'TaskListClock',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>